// extracted by css-extract-rspack-plugin
export default {"base":"Tag__base--z7k1c","default":"Tag__default--NlvP_ Tag__base--z7k1c","blue":"Tag__blue--NWf8c Tag__base--z7k1c"};